// extracted by mini-css-extract-plugin
export default {"productDescription":"Caa-z","featuredDescription":"Daa-z","description":"Eaa-z","more":"Faa-z","descriptionSku":"Gaa-z"};